export const SpeechSkipClassName = "speech-skip-target";
